import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { PrimaryButtonComponent } from './primary-button/primary-button.component';
import { SecondaryButtonComponent } from './secondary-button/secondary-button.component';

@NgModule({
    imports: [CommonModule, ButtonsModule, IconsModule, PrimaryButtonComponent, SecondaryButtonComponent],
    exports: [PrimaryButtonComponent, SecondaryButtonComponent],
})
export class ButtonsComponentsModule {}
